module.exports = __webpack_public_path__ + "static/img/c3.0ef5728c.svg";